import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import FuelPortal from './components/FuelPortal';
import GallonsToLiters from './pages/GallonsToLiters';
import LitersToGallons from './pages/LitersToGallons';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import FuelPricePage from './pages/FuelPricePage';
import fuelPricePages from './data/fuelPricePages';
// English versions
import FuelPortalEN from './pages/en/FuelPortal';
import GallonsToLitersEN from './pages/en/GallonsToLiters';
import LitersToGallonsEN from './pages/en/LitersToGallons';
import BlogEN from './pages/en/Blog';
import BlogPostEN from './pages/en/BlogPost';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* Polish routes */}
          <Route path="/" element={<FuelPortal />} />
          <Route path="/przelicznik-galony-na-litry" element={<GallonsToLiters />} />
          <Route path="/przelicznik-litry-na-galony" element={<LitersToGallons />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          {/* Fuel price SEO pages */}
          {fuelPricePages.map(pageConfig => (
            <Route
              key={pageConfig.slug}
              path={`/${pageConfig.slug}`}
              element={<FuelPricePage pageConfig={pageConfig} />}
            />
          ))}

          {/* English routes */}
          <Route path="/en" element={<FuelPortalEN />} />
          <Route path="/en/gallons-to-liters-converter" element={<GallonsToLitersEN />} />
          <Route path="/en/liters-to-gallons-converter" element={<LitersToGallonsEN />} />
          <Route path="/en/blog" element={<BlogEN />} />
          <Route path="/en/blog/:slug" element={<BlogPostEN />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
